import type { CandidateState } from "../../api/client";
import { reached, STATUS_LABEL, overallStatus } from "./status";

type ItemState = "done" | "current" | "todo";

function checklist(state: CandidateState): { label: string; state: ItemState; note?: string }[] {
  const items: { label: string; done: boolean; started?: boolean }[] = [
    { label: "Signed in with GitHub", done: true },
    { label: "CV added", done: Boolean(state.cv) },
    { label: "AI agent connected", done: reached(state, "mcp_connected") },
    { label: "Profile completed by your agent", done: reached(state, "profile_complete") },
    {
      label: "Thinking questions",
      done: reached(state, "thinking_submitted"),
      started: reached(state, "thinking_started"),
    },
  ];
  const firstOpen = items.findIndex((item) => !item.done);
  return items.map((item, i) => ({
    label: item.label,
    state: item.done ? "done" : i === firstOpen ? "current" : "todo",
    note: !item.done && item.started ? "in progress" : undefined,
  }));
}

export function ApplicationStatus({ state }: { state: CandidateState }) {
  const status = overallStatus(state);
  return (
    <section className="status-card" aria-label="Application status">
      <div className="status-head">
        <span className="muted">Application {state.public_id}</span>
        <span className={`status-pill ${status}`}>{STATUS_LABEL[status]}</span>
      </div>
      <ol className="checklist">
        {checklist(state).map((item) => (
          <li
            key={item.label}
            className={item.state}
            aria-current={item.state === "current" ? "step" : undefined}
          >
            {item.label}
            {item.note && <span className="muted"> · {item.note}</span>}
            <span className="visually-hidden">
              {item.state === "done" ? " (done)" : item.state === "current" ? " (next)" : ""}
            </span>
          </li>
        ))}
      </ol>
    </section>
  );
}
